import {Notification} from "./Notification";

export class NoNotification extends Notification {
	notify(): void {}
}
